import { render, staticRenderFns } from "./ListaParametros.vue?vue&type=template&id=00470c65"
import script from "./ListaParametros.vue?vue&type=script&lang=js"
export * from "./ListaParametros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports